import { ResetPasswordPage } from './pages/reset-password.page';
import { Routes, Route, RouterModule } from '@angular/router';

import * as pages from './pages';

export const AUTH_ROUTES: Routes = [
  { path: 'reset/confirm', component: pages.ResetPasswordPage, data: { name: 'Reset Password' } }
];



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/auth.routes.ts